import ProjectTable from './project-table';

export default ProjectTable;
